import { render, staticRenderFns } from "./FooterBot.vue?vue&type=template&id=35cce94e&scoped=true&"
import script from "./FooterBot.vue?vue&type=script&lang=js&"
export * from "./FooterBot.vue?vue&type=script&lang=js&"
import style0 from "./FooterBot.vue?vue&type=style&index=0&id=35cce94e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cce94e",
  null
  
)

export default component.exports